import { FC } from 'react';
import classNames from 'classnames';

import { SvgIconComponent } from '../types/svgs';

import Button from './Button';

const EmptyProfileTab: FC<{
  IconComponent: SvgIconComponent;
  titleText: string;
  subTitleText: string;
  iconClassName: string;
  onClickButton?: () => void;
  buttonTitle?: string;
  buttonDisabled?: boolean;
  ButtonIconComponent?: SvgIconComponent;
  className?: string;
  ButtonComponent?: React.ReactNode;
}> = ({
  IconComponent,
  titleText,
  subTitleText,
  iconClassName,
  onClickButton,
  buttonTitle,
  buttonDisabled,
  ButtonIconComponent,
  className,
  ButtonComponent,
}) => {
  return (
    <div
      className={classNames(
        'flex h-[calc(100vh-320px)] w-full flex-col items-center pt-16',
        className,
      )}
    >
      <IconComponent className={classNames('mb-5 h-20', iconClassName)} />
      <span className="mb-2 text-center text-body font-bold text-green-150">
        {titleText}
      </span>
      <span className="mb-11 w-[450px] text-center text-caption font-medium text-neutral-125/80">
        {subTitleText}
      </span>
      <div className="flex flex-row gap-x-3">
        {onClickButton && (
          <Button
            theme="secondary"
            size="small"
            className="mt-4 px-6"
            title={buttonTitle}
            IconComponent={ButtonIconComponent}
            iconClassName="h-[18px] w-[18px]"
            onClick={onClickButton}
            disabled={buttonDisabled}
          />
        )}
        {ButtonComponent && ButtonComponent}
      </div>
    </div>
  );
};

export default EmptyProfileTab;
